// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__r5qW8","InstrumentBlock":"styles_InstrumentBlock__rIlhl"};